module.exports = __webpack_public_path__ + "img/icon_sm_yclcksh.e2ec43a1.png";